import { toast } from "sonner";
import { Link } from "react-router-dom";
import { ArrowRight, Plus } from "lucide-react";
import { useCart, boxBags } from "@/lib/cart";
import { bagsOf, isBuilder, useFlavourStock } from "@/lib/shop";
import { FLAVOURS } from "@/data/content";

const base = "inline-flex items-center justify-center gap-2 rounded-full h-12 px-6 font-bold text-sm whitespace-nowrap transition-[background-color,color,transform] duration-300 active:scale-95";

const OutOfStock = ({ testid, className }) => (
  <button disabled data-testid={testid} className={`${base} bg-[#1B1530]/10 text-[#4A4560] cursor-not-allowed ${className}`}>Out of stock</button>
);

export const AddButton = ({ product, image, testid, comingSoon, className = "" }) => {
  const { add, setOpen, items } = useCart();
  const stock = useFlavourStock();
  if (!product && comingSoon) return <OutOfStock testid={testid} className={className} />;
  if (!product) return <button disabled data-testid={testid} className={`${base} bg-[#1B1530]/10 text-[#4A4560] ${className}`}>Loading…</button>;
  if (isBuilder(product)) {
    return <Link to={`/build?size=${bagsOf(product.title)}`} data-testid={testid} className={`${base} bg-[#FF5A5F] text-white hover:bg-[#1B1530] ${className}`}>Build your box <ArrowRight className="h-4 w-4" /></Link>;
  }
  // flavour packs draw on that flavour's bag count, minus bags already in the cart
  const f = FLAVOURS.find((x) => product.title.toLowerCase().includes(x.match));
  const enough = !f || stock[f.key] - (boxBags(items)[f.name] || 0) >= bagsOf(product.title);
  if (!enough) return <OutOfStock testid={testid} className={className} />;
  const onAdd = () => {
    add(product, image);
    toast.success(`${product.title} added to cart`);
    setOpen(true);
  };
  return (
    <button data-testid={testid} onClick={onAdd} className={`${base} bg-[#1B1530] text-white hover:bg-[#FF5A5F] ${className}`}>
      <Plus className="h-4 w-4" /> Add to cart
    </button>
  );
};
